/*
  Manse: copy the photocard choice into the order note.

  The card a customer picks is saved as a line item property ("Photocard") on the
  product they add. On bundles (the OTOKI 5-packs) the Shopify mobile app shows only
  the bundle's components, so the property is hidden there. The order note shows in
  every Shopify app, so this script keeps one line in the cart note, for example:

    PHOTOCARDS: JIN Mild (Pack of 5) x1 = SUGA; JIN Mild (Pack of 5) x1 = JUNGKOOK

  - After every cart add / change / update / clear, the line is rebuilt from the cart.
  - Anything the customer wrote in the note is kept; only the PHOTOCARDS line is ours.
  - Checkout waits for a pending update, so the note is never left behind.
  - "Buy it now" on a product with a card picker adds to the cart first, then goes to
    checkout, because Buy it now skips the cart and its note.
*/
(function () {
  if (window.__mhCardNote) return;
  window.__mhCardNote = true;

  var MARK = 'PHOTOCARDS:';
  var PROP = 'Photocard';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  var timer = null;
  var pending = null;

  function shortName(item) {
    return String(item.product_title || item.title || '')
      .replace(/^OTOKI\s+/i, '')
      .replace(/\s+Ramen Noodle Soup/i, '')
      .trim();
  }

  function cardLine(cart) {
    var parts = [];
    (cart.items || []).forEach(function (item) {
      var card = item.properties && item.properties[PROP];
      if (card) parts.push(shortName(item) + ' x' + item.quantity + ' = ' + card);
    });
    return parts.length ? MARK + ' ' + parts.join('; ') : '';
  }

  function sync() {
    return nativeFetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var old = cart.note || '';
        var kept = old.split('\n').filter(function (l) { return l.indexOf(MARK) !== 0; }).join('\n').trim();
        var line = cardLine(cart);
        var note = [kept, line].filter(Boolean).join('\n');
        if (note === old) return;
        return nativeFetch(root + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: note })
        });
      })
      .catch(function () {});
  }

  var resolvePending = null;
  var seq = 0;

  // One promise covers a burst of cart writes; it resolves after the last sync.
  function schedule() {
    seq++;
    clearTimeout(timer);
    if (!pending) pending = new Promise(function (resolve) { resolvePending = resolve; });
    timer = setTimeout(run, 120);
    return pending;
  }

  function run() {
    var mine = seq;
    sync().then(function () {
      if (mine !== seq || !resolvePending) return;
      var done = resolvePending;
      pending = null;
      resolvePending = null;
      done();
    });
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || String(input || '');
    var result = nativeFetch(input, init);
    if (CART_WRITE.test(url)) result.then(schedule, function () {});
    return result;
  };

  function goToCheckout() {
    window.location.href = root + 'checkout';
  }

  // Cart page / drawer checkout: wait for a pending note update first.
  document.addEventListener('submit', function (e) {
    if (!pending) return;
    var form = e.target;
    var submitter = e.submitter;
    var toCheckout = (submitter && submitter.name === 'checkout') || /\/checkout/.test(form.getAttribute('action') || '');
    if (!toCheckout) return;
    e.preventDefault();
    pending.then(goToCheckout);
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var link = t.closest('a[href$="/checkout"]');
    if (link && pending) {
      e.preventDefault();
      pending.then(goToCheckout);
      return;
    }

    var buyNow = t.closest('shopify-buy-it-now-button, shopify-accelerated-checkout, .shopify-payment-button');
    if (!buyNow) return;
    var form = buyNow.closest('form');
    if (!form) {
      var host = buyNow.closest('[data-product-form], product-form-component, .product-form, .buy-buttons-block');
      form = host && host.querySelector('form[action*="/cart/add"]');
    }
    if (!form || !form.elements || !form.elements['properties[' + PROP + ']']) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    if (!form.reportValidity()) return;

    nativeFetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function () { return sync(); })
      .then(goToCheckout, goToCheckout);
  }, true);

  // Carts filled before this script existed get their line on the next page view.
  if (document.cookie.indexOf('cart=') !== -1) schedule();
})();
